/* eslint-disable
    @typescript-eslint/no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const ApiError = require('app/scripts/network/api-error');
const { logError } = require('app/scripts/debug/log-error');
const { sendCrashEvent } = require('@trello/error-reporting');
const errorSignal = require('app/scripts/lib/error-signal');
const _ = require('underscore');
const f = require('effing');

const isInterestingError = (err) =>
  err instanceof ApiError.Other || !(err instanceof ApiError);

const hasTraceId = (err) => 'traceId' in err;

const pastErrors = [];

errorSignal.subscribe(
  _.debounce(
    function (errorInfo) {
      // We want to avoid a situation where a client gets into an infinite error
      // loop and spams us over and over, and our deduplicator fails to detect that.
      if (pastErrors.length === 10) {
        return false;
      }

      const { error, url, line, col } = errorInfo;

      if (!isInterestingError(error) && !hasTraceId(error)) {
        return false;
      }

      // We only care if it's one of our scripts that's having an error.
      // We don't care if it's an extension (or script related to an extension)
      if (
        !new RegExp(
          `https?://(${location.host}|[a-z0-9]+\\.cloudfront\\.net|a.trellocdn.com)/`,
        ).test(url)
      ) {
        return false;
      }

      const errorEntry = [error.message, url, line, col];

      if (_.any(pastErrors, f(_.isEqual, errorEntry))) {
        return false;
      }

      sendCrashEvent(error);
      pastErrors.push(errorEntry);
      return false;
    },
    1000,
    true,
  ),
);
